import { Injectable } from '@angular/core';
import { app } from '@df/core/app';
import defaults from 'lodash-es/defaults';
import { ElementHeightService } from '@df/dom/element-height/element-height.service';
import { getAbsolutePosition } from '@df/dom/fn/get-absolute-position';

export const DEFAULT_SCROLLTO_OPTIONS: IScrollToOptions = {
    offset: undefined,
    behavior: 'smooth'
};
export interface IScrollToOptions {
    offset?: number;
    offsetAdd?: number;
    behavior?: 'smooth' | 'auto';
}

@Injectable({
    providedIn: 'root'
})
export class ScrollToService {
    constructor(private elementHeightService: ElementHeightService) {}

    scrollTo(target: Element | number | string, options: Partial<IScrollToOptions> = {}) {
        defaults(options, DEFAULT_SCROLLTO_OPTIONS);
        const root = app.client.getRootElement();
        if (typeof target !== 'number') {
            if (typeof target === 'string') {
                target = document.querySelector(target)!;
            }
            if (!target) {
                return;
            }
            if (!root.contains(target)) {
                target.scrollIntoView(options);
                return;
            }
            target = getAbsolutePosition(target as HTMLElement).y - getAbsolutePosition(root).y;
        }
        // with this logic offset is automatically calculated basing on element height directive
        const offset =
            typeof options.offset === 'undefined' ? this.elementHeightService.getTopOffset() + (options.offsetAdd || 20) : options.offset;
        root.scrollTo({ top: target - offset, behavior: options.behavior });
    }

    
}
